'use client';

import { useAuthSession, type SessionUser } from '@/components/rbac/AuthSessionProvider';

type ProfileSuffix = '' | '/editar' | '/exportar';

/**
 * URL del perfil propio, ya resuelta al slug público.
 *
 * Enlazar a `/mi-perfil` funciona (redirige), pero el usuario paga el salto: se
 * ve como si la navegación fallara y rebotara, y cuesta un viaje extra al server.
 * Con el slug ya en la sesión, el enlace apunta al destino final desde el principio.
 *
 * Cae a `/mi-perfil` mientras la sesión carga o cuando no hay slug (cuenta sin
 * investigador vinculado): esa ruta resuelve el destino en el server y muestra el
 * estado "sin perfil" cuando corresponde.
 */
export function myProfileHref(
	user: Pick<SessionUser, 'slug'> | null | undefined,
	suffix: ProfileSuffix = '',
) {
	if (!user?.slug) return '/mi-perfil';
	return `/investigadores/${encodeURIComponent(user.slug)}${suffix}`;
}

/** Variante para componentes que leen la sesión del contexto. */
export function useMyProfileHref(suffix: ProfileSuffix = '') {
	const { user } = useAuthSession();
	return myProfileHref(user, suffix);
}
